var API_DOMAIN = "https://kalaicrackers.in/api";

export default API_DOMAIN;
